import React from 'react';
import ExportButton from './ExportButton';
import { Car } from '../entities/car.entities';
import { RequestBody } from '../services/api';

interface HeaderProps {
    theme: 'light' | 'dark';
    toggleTheme: () => void;
    onToggleSidebar: () => void;
    currentPageData: Car[];
    totalCount: number;
    requestBody: RequestBody;
    onExportAll: (format: 'csv' | 'json') => void;
}

const Header: React.FC<HeaderProps> = ({
    theme,
    toggleTheme,
    onToggleSidebar,
    currentPageData,
    totalCount,
    requestBody,
    onExportAll
}) => {
    return (
        <header className="app-header">
            <div className="header-left">
                <button
                    className="main-button"
                    onClick={onToggleSidebar}
                    title="Toggle filters"
                >
                    <svg className="filter-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                    </svg>
                </button>
            </div>
            <div className="header-center">
                <img src="/logo.svg" alt="Carsure Logo" style={{ height: '48px' }} />
                <h1 className='logo'>
                    Carsure
                </h1>
            </div>
            <div className="header-right">
                <div className="theme-toggle-wrapper" title="Toggle Theme">
                    <div className="theme-toggle" onClick={toggleTheme}>
                        <div className="theme-toggle-thumb">
                            {theme === 'dark' ? (
                                <svg className="toggle-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>
                            ) : (
                                <svg className="toggle-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
                            )}
                        </div>
                    </div>
                </div>
                <ExportButton
                    currentPageData={currentPageData}
                    totalCount={totalCount}
                    requestBody={requestBody}
                    onExportAll={onExportAll}
                />
            </div>
        </header>
    );
};

export default Header;
